app.factory('errorService', function($rootScope) {
    return {
        reset: function(){
            $rootScope.errors = [];
        },
        error: function(title,message,type) {
            $rootScope.errors.push({
                type: type || 'danger',
                title: title,
                message: message,
            });
        }
    };
});